import { render } from "./CartRecap.vue?vue&type=template&id=4afadfcb&scoped=true"
import script from "./CartRecap.vue?vue&type=script&lang=js"
export * from "./CartRecap.vue?vue&type=script&lang=js"

import "./CartRecap.vue?vue&type=style&index=0&id=4afadfcb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afadfcb"]])

export default __exports__